module.exports = __webpack_public_path__ + "img/img_8.dc899d1b.png";